import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { InternetService } from '@wheere-front/shared-util';
import { OfflineComponent } from './offline.component';

@Component({
  selector: 'lib-shell',
  standalone: true,
  imports: [NgClass, OfflineComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .shell-content {
      /* Fixed height (was min-height) so the app is exactly one viewport tall — no page scroll.
         Long pages scroll INSIDE main; the fixed navbar stays put. 100dvh tracks the mobile
         URL-bar. Full-height pages (e.g. the site Point map) can just use h-full. */
      height: calc(100vh - var(--topnav-height));
      margin-top: var(--topnav-height);
      overflow-x: hidden;
      overflow-y: auto;
    }
  `,
  template: `
    <ng-content select="[slot=navbar]" />
    <div class="mx-auto flex w-full justify-center">
      <ng-content select="[slot=sidenav]" />

      <main
        [ngClass]="{
          'bg-gray-50/75': !isHome(),
          'p-4': withPadding(),
        }"
        class="shell-content relative mt-[var(--topnav-height)] block w-full text-gray-900 dark:bg-slate-900 dark:text-slate-100">
        @if (isOnline()) {
          <ng-content> </ng-content>
        } @else {
          <lib-offline />
        }
      </main>
    </div>
  `,
})
export class ShellComponent {
  isHome = input(false, { transform: booleanAttribute });
  withPadding = input(true, { transform: booleanAttribute });
  isOnline = inject(InternetService).isOnline;
}
